<app-button-close *ngIf="!beneficiaryId"
                  appNavigateBack>
</app-button-close>

<app-listing
    [exportHeaders]="columnsForCSVExport"
    [exportName]="exportName"
    [key]="listingId"
    searchBarPlaceholder="N° de facture, libellé, montant, ...">

    <!-- titre du listing -->
    <ng-template *ngIf="!beneficiaryId"
                 appListingTitle>
        Liste des factures bénéficiaires
    </ng-template>

    <ng-template appListingCountResultsLabel let-nbOfElements="nbOfElements">
        {nbOfElements, plural,
            =0 { 0 facture }
            one { {{ nbOfElements }} facture }
            other { {{ nbOfElements }} factures }}
    </ng-template>

    <!-- Remplacement de la searchbar par le kal-select -->
    <ng-template *ngIf="beneficiaryId"
                 appListingSearchbarContent>

        <div class="invoiceTypes">

            <span>
                <strong> Type</strong>
            </span>

            <kal-form-field class="without-label gup-C-formFieldSize--bottomNull">

                <kal-select [formControl]="invoiceTypeControl"
                            multiple
                            placeholder="Tous">
                    <kal-option value="IsFacture">Factures</kal-option>
                    <kal-option value="IsAvoir">Avoirs</kal-option>
                    <kal-option value="IsAcompte">Acomptes</kal-option>
                </kal-select>

            </kal-form-field>

        </div>

    </ng-template>

    <!-- filtres du listing-->
    <app-shared-invoices-filters [beneficiaryId]="beneficiaryId">
    </app-shared-invoices-filters>

    <ng-template appListingAfterSearchbarButtons>

        <div class="gup-C-actionGrouped__actionlinks" *ngIf="isFreeQueryParam">
            <a (click)="navigateToFreeEntryInvoiceCreate()"
               class="gup-C-moreInfos gup-O-link">
                <kal-icon>add</kal-icon>
                <span>Créer une nouvelle facture</span>
            </a>
        </div>

    </ng-template>

    <!-- tableau du listing -->
    <kal-table
        #table
        [actionable]="hasVersion"
        [columns]="columns"
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [virtualItemSize]="30"
        [virtualRowClassFunction]="virtualRowClassFunction"
        class="no-action"
        [virtual]="!beneficiaryId">

        <tr *kalHeaderRowDef kal-header-row></tr>

        <ng-container kalColumn="StatutFacture">
            <td *kalBodyCell="let element"
                [class]="getStatusClass(element.StatutFacture).class">
                {{ getStatusClass(element.StatutFacture).label }}
            </td>
        </ng-container>

        <ng-container kalColumn="DateFacture">
            <td *kalBodyCell="let element">{{ element.DateFacture  | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container kalColumn="NumFacture">
            <td *kalBodyCell="let element">
                <a (click)="canNavigateToInvoice(element) && navigateToInvoiceDetail(element)"
                   [class.--unlinkable]="!canNavigateToInvoice(element)">
                    {{ element.NumFacture }}
                </a>
            </td>
        </ng-container>

        <ng-container kalColumn="MontantFacture">
            <td *kalBodyCell="let element">{{ element.MontantFacture | currency:'EUR' }}</td>
        </ng-container>

        <ng-container kalColumn="Solde">
            <td *kalBodyCell="let element">{{ element.Solde | currency:'EUR' }}</td>
        </ng-container>

        <ng-container kalColumn="BenefNom">
            <td *kalBodyCell="let element">
                <a (click)="navigateToBeneficiaryDetail(element.IdBenef)">
                    {{ getBenefFullNameWithSerial(element) }}
                </a>
            </td>
        </ng-container>

        <ng-container kalColumn="TypeFacture">
            <td *kalBodyCell="let element">
                {{ getInvoiceTypeLabel(element) }}
            </td>
        </ng-container>

        <ng-container *ngIf="hasVersion"
                      [kalColumn]="table.actionColumnName">
            <td *kalBodyCell="let row">

                <div>

                    <app-shared-comment-table [privateComment]="row.RemarquePrivee"
                                              [publicComment]="row.RemarquePublique">
                    </app-shared-comment-table>

                    <kal-button (click)="stopPropagation($event)"
                                [kalMenuTriggerFor]="actionsMenu"
                                kalTheme="tertiary">
                        <kal-icon>more_horiz</kal-icon>
                    </kal-button>

                    <kal-menu #actionsMenu>
                        <kal-option (selectionChange)="navigateToInvoiceDetail(row)"
                                    *ngIf="canNavigateToInvoice(row)">
                            Voir la facture
                        </kal-option>
                        <kal-option (selectionChange)="navigateToOrderDetail(row)"
                                    *ngIf="canNavigateToOrderDetail(row)">
                            Voir la commande
                        </kal-option>
                        <kal-option (selectionChange)="openCreditDialog(row)"
                                    *ngIf="row.IsFacture && !row.IsSupprime && row.MontantFacture > 0">
                            Créer un avoir
                        </kal-option>
                        <kal-option (selectionChange)="openAdvancedPaymentDialog(row)"
                                    *ngIf="!row.IsSupprime && row.StatutFacture !== 'SLD'">
                            {{ row.IsFacture ? 'Régler' : 'Rembourser' }}
                        </kal-option>
                        <kal-option (selectionChange)="openPrintDialog(row)"
                                    *ngIf="!row.IsAcompte">
                            Imprimer {{ getLabel(row) }}
                        </kal-option>
                        <kal-option (selectionChange)="openChequeLetterDialog(row)"
                                    *ngIf="row.IsAvoir && !row.IsSupprime">
                            Imprimer la lettre chèque
                        </kal-option>
                        <kal-option (selectionChange)="sendMail(row)">Envoyer par e-Mail</kal-option>
                        <kal-option (selectionChange)="delete(row)"
                                    *ngIf="!row.IsSupprime">
                            Supprimer {{ getLabel(row) }}
                        </kal-option>
                        <kal-option (selectionChange)="openCommentDialog(row)">
                            {{!!row.RemarquePublique || !!row.RemarquePrivee ? 'Modifier les' : 'Ajouter des'}}
                            commentaires
                        </kal-option>
                    </kal-menu>

                </div>

            </td>
        </ng-container>

    </kal-table>

</app-listing>
